import { isAxiosError } from 'axios';

const apiErrorMessage = (error: unknown, fallback: string): string => {
  if (isAxiosError<{ message?: string }>(error)) {
    return error.response?.data.message ?? fallback;
  }

  return fallback;
};

export default apiErrorMessage;
